import React from 'react'
import { useState, useContext } from 'react';

import Button from '../../components/Button'
import CustomeIcon from '../../components/CustomeIcon';

import Helper from '../../utils/Helper';
import CartContext from '../../store/cart-context'
const MenuItem = (props) => {
  const helperFunc = Helper();
//   const DOMHandlerHelper = DOMHandler();
  
//   console.log('cardDetails', props)
const cartCtx = useContext(CartContext);
let finalTitle = props.cardDetails.title;

// cartCtx.additem(props.cardDetails);
// console.log('MenuItem Loaded.......', props);

// console.log('finditem-----', cartCtx.finditem(props.cardDetails.title));
// console.log('finditem-----', helperFunc.menuItemFindInCart(props.cardDetails.title, cartCtx.items));
// if(props.classList=='active'){
//   props.productStateSelectContext[props.itemCategory] = props.cardDetails.title
// }
// console.log("the cam angle",props);

// let menuTitle;


// if(props.cardDetails.title == "Remove-the-microwave-drawer"){
//     menuTitle = props.cardDetails.title.replace(/-/gm," ");
// }else{
//   menuTitle = props.cardDetails.title;
// }

if(finalTitle === "SMD2470AS"){
  finalTitle = "SMD2470ASY"
}else{
  finalTitle = finalTitle;
}


  return (
    <div
      className={props.cardDetails.title + ' ' + props.classList + ' menuItem'}
      id={props.cardDetails.title.replace(/\s/g, '')}
    >
      <Button
        classList="menuItemContent"
        btnId={props.productId}
        data={props}
        clickFunction={props.productCardFunc}
        
      >
        <h3 className="heading"> {finalTitle}</h3>
        <div className="menuItemBody">
          <p className="descriptionText">{props.cardDetails.description}</p>

          <div className='cardImg'>
            <CustomeIcon
              src={props.cardDetails.thumbnail}
              alt={props.cardDetails.title}
              classList="menuThumb"
            ></CustomeIcon>
          </div>
        
        </div>
      </Button>
      {
        props.cardDetails.downloadSpec && <a className='btn downloadSpec' target='_blank' href={props.cardDetails.downloadSpec}>Download Spec Sheet</a>
      }

      { !helperFunc.menuItemFindInCart(props.cardDetails.title, cartCtx.items) ? ( // When we add Cart functionality we need to change here
        <Button
          btnId={props.cardDetails.title + '-cart'}
          classList="btn addToCart"
          data={props}
          // clickFunction={props.addToCartHandlerFunc}
          clickFunction={cartCtx.additem}
        >
          Add to My Kitchen
        </Button>
      ) : (
        <Button
          btnId={props.cardDetails.title + '-cart'}
          classList="btn removeFromCart"
          data={props.cardDetails.title}
          // clickFunction={props.removeCartHandlerFunc}
          clickFunction={cartCtx.removeItem}
        >
          Remove From My Kitchen
        </Button>
      )}


    </div>
  )
}

export default MenuItem
